import axios from 'axios';

function getAxiosErrors(error: unknown): { [key: string]: any } {
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.errors) {
      return error.response.data.errors;
    } else if (error.response?.data?.message) {
      return { errorMessage: [error.response.data.message] };
    } else {
      return { errorMessage: ['Unknown error'] };
    }
  } else if (error instanceof Error) {
    console.log(error.message);
    return {
      errorMessage: [error.message],
    };
  } else if (typeof error === 'object' && error !== null && 'errors' in error) {
    return (
      (error.errors as { [key: string]: any }) || {
        errorMessage: ['Unknown error'],
      }
    );
  } else {
    return {
      errorMessage: [
        (error as { message: string })?.message || 'Unknown error',
      ],
    };
  }
}

export default getAxiosErrors;
